import { FC, useState } from 'react'
import {
  Alert,
  Button,
  EmailField,
  EmailRegex,
  ForgotPasswordContainer,
  makeStyles,
  PageTitle,
} from '@perk-ui/core'

import AuthBackground from '../../components/AuthBackground'
import { useAuth } from '../../features/auth/AuthContext'

const useStyles = makeStyles((theme) => ({
  password: {
    marginTop: theme.spacing(3),
  },
  loginButton: {
    marginTop: theme.spacing(3),
  },
  alert: {
    color: theme.palette.success.dark,
  },
}))

interface ErrorState {
  email?: string
}

interface ForgotPasswordProps {}

const ForgotPassword: FC<ForgotPasswordProps> = () => {
  const classes = useStyles()
  const { requestPasswordReset } = useAuth()
  const [username, setUsername] = useState<string>('')
  const [emailSent, setEmailSent] = useState(false)
  const [errors, setErrors] = useState({} as ErrorState)
  const [loading, setLoading] = useState(false)

  const handleResetEmailClick = () => {
    if (!EmailRegex.test(username)) {
      setErrors({
        email: 'Invalid email format',
      })
      return
    }

    setLoading(true)
    return requestPasswordReset(username)
      .then(() => {
        setEmailSent(true)
      })
      .finally(() => {
        setLoading(false)
        setErrors({} as ErrorState)
      })
  }

  return (
    <AuthBackground>
      <PageTitle title="Forgot Password" />
      <ForgotPasswordContainer
        MessagesComponent={
          emailSent && (
            <Alert className={classes.alert} severity="success" fade grow>
              {
                "If an account exists with this email address, you'll receive an email with instructions to reset your password."
              }
            </Alert>
          )
        }
        UsernameComponent={
          <EmailField
            id="forgot-password-email"
            value={username}
            onChange={(ev) => setUsername(ev.target.value)}
            helperText={errors?.email}
            error={Boolean(errors.email)}
          />
        }
        ButtonComponent={
          <Button
            id="forgot-password-button"
            className={classes.loginButton}
            loading={loading}
            onClick={handleResetEmailClick}
          >
            Request reset email
          </Button>
        }
        loginURL="/login"
      />
    </AuthBackground>
  )
}

export default ForgotPassword
